import { BaseCommand } from '../ICommand';
import { getNodeMutationManager } from '../mutations/NodeMutationManager';
import type { Edge } from '../../models/scene';

export interface AutoPathEdgeUpdate {
  edgeId: string;
  updates: Partial<Edge>;
}

/**
 * Auto-pathing is derived behavior (anchors are a function of node geometry unless locked).
 * This command is executed via CommandManager but is skipped from history to avoid
 * polluting undo/redo with non-user-facing steps.
 */
export class AutoPathEdgesCommand extends BaseCommand {
  private edgeUpdates: AutoPathEdgeUpdate[];
  private prevById: Map<string, Edge> = new Map();

  constructor(edgeUpdates: AutoPathEdgeUpdate[]) {
    super(
      'Auto Path Edges',
      `Auto-update anchors for ${edgeUpdates.length} edges`,
      { skipHistory: true }
    );
    this.edgeUpdates = edgeUpdates;
  }

  execute(): void {
    if (this.edgeUpdates.length === 0) return;
    const mm = getNodeMutationManager() as any;
    mm.runInTransaction(() => {
      for (const { edgeId, updates } of this.edgeUpdates) {
        try {
          const prev = typeof mm.getEdge === 'function' ? (mm.getEdge(edgeId) as Edge | undefined) : undefined;
          if (prev && !this.prevById.has(edgeId)) {
            this.prevById.set(edgeId, { ...prev, attrs: { ...(prev.attrs || {}) } } as Edge);
          }
          mm.updateEdge(edgeId, updates);
        } catch {}
      }
    }, 'auto-path-edges');
  }

  undo(): void {
    if (this.prevById.size === 0) return;
    const mm = getNodeMutationManager() as any;
    mm.runInTransaction(() => {
      for (const [edgeId, prev] of this.prevById.entries()) {
        try { mm.updateEdge(edgeId, prev); } catch {}
      }
    }, 'auto-path-edges:undo');
  }
}

